import { fetchApi } from '@/config/axiosSetting';
import { GetCulpritPropertyInsurancePropType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritPropertyInsurance/getCulpritPropertyInsurance.type';
import { PropertyInsuranceResponseType } from '@/modules/adjusterReportModules/IncidentParticipants/types/PropertyInsurance.type';

export const getCulpritPropertyInsuranceFunction = (
  params: GetCulpritPropertyInsurancePropType,
): Promise<PropertyInsuranceResponseType> => {
  return fetchApi.get(
    `/property/reports/${params.id}/accident_users/culprit/insurance_information/`,
  );
};
